import routes from "@/routes/routes";
import type { ComponentType } from "react";
import type { RouteConfig } from "@/types/routestypes";

export interface SidebarChild {
  id: string;
  path: string;
  icon?: ComponentType<any> | undefined;
  pageName?: string | undefined;
  permissionName?: string | undefined;
}

export interface SidebarItem {
  id: string;
  path: string;
  icon?: SidebarChild["icon"];
  pageName?: string | undefined;
  permissionName?: string | undefined;
  section?: string | undefined;
  mobileOnly?: boolean | undefined;
  children?: SidebarChild[];
}

export const SIDEBAR_SECTION_ORDER = [
  "Overview",
  "Membership",
  "Programming",
  "Revenue",
  "Engagement",
  "System",
] as const;

// Derived from `routes.privateRoutes` — a route only shows up here once it
// declares `sidebar: { show: true, ... }` on itself (see the DASHBOARD
// entry in `routes.tsx` for the shape). Add a route there, not here.
export const sideBarNavigation: SidebarItem[] = Object.values(routes.privateRoutes)
  .filter((page) => page.sidebar?.show || page.children)
  .map((pageData, index) => {
    const data: SidebarItem = {
      id: (index + 1).toString(),
      path: pageData.path,
      icon: pageData.sidebar?.icon,
      pageName: pageData.sidebar?.name || pageData.pageName,
      permissionName: pageData.permissionName,
      section: pageData.sidebar?.section,
      mobileOnly: pageData.sidebar?.mobileOnly,
    };

    if (pageData.children) {
      const children: RouteConfig[] = Array.isArray(pageData.children)
        ? pageData.children
        : Object.values(pageData.children);

      data.children = children
        .filter((child) => child.sidebar?.show)
        .map((child, childIndex) => ({
          id: `${index + 1}-${childIndex + 1}`,
          path: child.path ?? "",
          icon: child.sidebar?.icon,
          pageName: child.sidebar?.name || child.pageName,
          permissionName: child.permissionName,
        }));
    }

    return data;
  });
